var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.playerMethod)?_c('span',[_c('video-player',{staticClass:"fid-player-underlay",attrs:{"vimeo-file":_vm.vimeoFile,"film-files":_vm.filmFiles,"poster":_vm.poster,"autoplay":_vm.autoplay,"big":_vm.big,"film-master":_vm.filmMaster,"player-method":_vm.playerMethod}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }